import { CompanyIntroCard } from "./CompanyIntroCard";
import CompanyIntroDesc from "./CompanyIntroDesc";
import GHGView from "./GHGView";

const CompanyIntro = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        maxWidth: "100%",
        marginTop: "50px",
      }}
    >
      <CompanyIntroCard />
      <CompanyIntroDesc />
      <GHGView />
    </div>
  );
};

export default CompanyIntro;
